<template>
  <div class="loadingoverlay">
    <dual-ring-loader :color="'#EE786F'" class="loadingcircle" />
  </div> 
</template>
<script> 
import {DualRingLoader} from "vue-spinners-css";
export default {
  components: {
    DualRingLoader
  }
};
</script>
<style scoped>
.loadingoverlay {
  position: fixed;
  background: #000000;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 999999;
}
.loadingcircle {
  position: absolute;
  border-color: #EE786F transparent #EE786F transparent;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
}

>>> .lds-dual-ring-after {
  border-color: #EE786F transparent #EE786F transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue